import { getFormPropz } from '../../components/forms/props/formPropz';
import { grts, responseReducers } from './reducerHelpers/dispatchProps';

const rts = {
  // handleInit_formData: 'handleInit_formData',
  // handleInit_formProps: 'handleInit_formProps',
  handleInit_form: 'handleInit_form',
  handleLocalPropChange: 'handleLocalPropChange',
  ...grts
}

export const appFormReducer = (state, action) => {

  const { type, dispatch } = action
  const { formProps } = state

  const { handleLocalPropChange } = appFormHandlers(dispatch)
  const form_handlers = { handleFormDataChange_local: handleLocalPropChange }

  switch (type) {

    // case rts.handleInit_formData:
    //   return {
    //     ...state,
    //     data_appForm: action.data_appForm,
    //     formProps: { ...state.formProps, data_appForm: action.data_appForm }
    //   }

    // case rts.handleInit_formProps:
    //   return { ...state, ...action.formPropz }

    case rts.handleInit_form:
      const data = getFormInitXXX(state, action, form_handlers)
      if (action.defaultOptions) {
        Object.keys(action.defaultOptions).forEach(dpk => {
          if (data.viewProps && data.viewProps[dpk]) {
            data.viewProps[dpk].data.trueList = action.defaultOptions[dpk]
          }
        })
      }

      data.formProps.data_appForm = action.data_appForm
      data.formProps.data_init = action.data_appForm

      return {
        ...state,
        ...data,
        data_appForm: action.data_appForm,
        data_localForm: action.data_appForm,
        // formProps: {
        //   ...state?.formProps, 
        // }
      }

    case rts.handleLocalPropChange:
      return state
      return { ...state, data_appForm: action.data_changed }

    case rts.updateSuccess:
    case rts.updateSuccessAlt:
    case rts.updateError:
      return responseReducers(state, action, { questionProps: null })

    default:
      return { ...state }
  }
}

export const appFormInitialState = (initState) => {
  return { ...initState }
};

export const appFormHandlers = (dispatch) => {
  return {
    // handleInit_formData: (data_appForm) => { dispatch({ type: rts.handleInit_formData, dispatch, data_appForm }) },
    // handleInit_formProps: (formPropz) => { dispatch({ type: rts.handleInit_formProps, dispatch, formPropz }) },
    handleInit_form: (init_state, formPropz, data_appForm) => { dispatch({ type: rts.handleInit_form, dispatch, init_state, formPropz, data_appForm }) },
    handleLocalPropChange: (data_changed) => { dispatch({ type: rts.handleLocalPropChange, dispatch, data_changed }) },
  }
}

const getFormInitXXX = (state, action, form_handlers) => {

  const { appForms, appFormType, appFormTypes, appFormItems, propIgnores, vit } = state ?? {}
  const { init_state, formPropz } = action ?? {}
  const { formProps, viewProps } = formPropz ?? {}
  const { appFormType: appFormType_action } = init_state ?? {}


  const _appFormType = appFormType_action ? appFormType_action : appFormType

  const data = {
    formProps: null,
    viewProps: null,
    noProps: false,
  }

  if (formProps && viewProps) {
    data.formProps = formProps
    data.viewProps = viewProps
    if (form_handlers) {
      data.formProps.form_handlers = form_handlers
    }
    data.form_handlers = form_handlers
    return data
  }

  if (appForms) {
    if (appFormTypes) {
      let allViewProps = {}
      appFormTypes.forEach(aft => {
        if (appForms[aft]) {
          const _viewProps = appForms[aft]
          allViewProps = { ...allViewProps, ..._viewProps }
        }
      })
      if (allViewProps && propIgnores) propIgnores.forEach(pi => { delete allViewProps[pi] })
      const fpp = { form_handlers, updateProps: { vit }, viewProps: allViewProps }
      const _formProps = getFormPropz(fpp)
      data.formProps = _formProps
      data.viewProps = allViewProps
    } else if (_appFormType && appForms[_appFormType]) {
      const _viewProps = appForms[_appFormType]
      if (_viewProps && propIgnores) propIgnores.forEach(pi => { delete _viewProps[pi] })
      const fpp = { form_handlers, updateProps: { vit }, viewProps: _viewProps }
      const _formProps = getFormPropz(fpp)
      data.formProps = _formProps
      data.viewProps = _viewProps
    } else if (appFormItems) {
      const fpp = { form_handlers, updateProps: { vit }, viewProps: appFormItems }
      const _formProps = getFormPropz(fpp)
      data.formProps = _formProps
      data.viewProps = appFormItems
    } else {
      data.noProps = true
    }
  }

  return data
}